var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaRilassanteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.1,3.09A3.095,3.095,0,1,1,10,0,3.10485,3.10485,0,0,1,13.1,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.21,4.97a.20789.20789,0,0,0-.1-.06c.02,0,.03.01.05.02A.10025.10025,0,0,1,14.21,4.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.35,13.69l-3.17.53-2.6.43V11.27l1.21,1.2a.51331.51331,0,0,0,.74,0,.50173.50173,0,0,0,0-.73L11.42,9.63a.48845.48845,0,0,0-.57-.11.50984.50984,0,0,0-.32.48v4.82l-.53.09-.53-.08V10a.50984.50984,0,0,0-.32-.48.49134.49134,0,0,0-.57.11L6.47,11.74a.50163.50163,0,0,0,0,.73.51331.51331,0,0,0,.74,0l1.21-1.2v3.38l-1.11-.18-1.34-.22-3.32-.56.27-.94.02-.08.62-2.19.95-3.34A3.45091,3.45091,0,0,1,5.5,5.25l.24-.24A.21835.21835,0,0,1,5.79,4.97a.19768.19768,0,0,1,.11-.06c.01-.02.02-.03.04-.02a.4496.4496,0,0,1,.28-.03.38052.38052,0,0,1,.1.03.55255.55255,0,0,1,.08.05A.23581.23581,0,0,1,6.49,5a.31308.31308,0,0,1,.08.11,3.98121,3.98121,0,0,0,6.86,0A.33277.33277,0,0,1,13.52,5a.49861.49861,0,0,1,.17-.11.42092.42092,0,0,1,.2-.04.31952.31952,0,0,1,.14.03.067.067,0,0,1,.08.03.20789.20789,0,0,1,.1.06.21788.21788,0,0,1,.05.04l.25.24a3.63451,3.63451,0,0,1,1,1.94l.85,3.01.7,2.47.03.09V12.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.31 14.47 8.42 14.65 8.42 14.66 7.31 14.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.18 14.22 11.58 14.66 11.58 14.65 14.18 14.22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.26,5v.01a.21788.21788,0,0,0-.05-.04A.085.085,0,0,1,14.26,5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.37A2.63321,2.63321,0,0,1,17.37,20H2.63a2.63,2.63,0,0,1,0-5.26h.08l.56.08,6.78.97h.02l3.02-.44,1.87-.27L16.72,14.82l.58-.08h.07A2.63321,2.63321,0,0,1,20,17.37Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaRilassanteFill);
export default __webpack_public_path__ + "static/media/iconaRilassanteFill.89528d72cbd2e0daf181ab88673088ca.svg";
export { ForwardRef as ReactComponent };